import type { ChangelogEntry } from "../types";

/** VIB-2930: alle innloggede kunne endre fordelingen av bilag på alle prosjekter. */
export const BILAGSFORDELING_TILGANG_2026_10: ChangelogEntry = {
  id: "2026-10-24-bilagsfordeling-tilgang",
  date: "2026-10-24",
  title: "Bare prosjektleder, kunderådgiver og admin kan fordele bilag",
  summary:
    "Fordeling av bokførte bilag på budsjettlinjer krever nå samme tilgang som å godkjenne bilag på prosjektet. Andre ser fordelingen, men kan ikke endre den.",
  sections: [
    {
      heading: "Inne på et prosjekt",
      minRole: "user",
      items: [
        {
          title: "«Fordel» vises bare for dem som kan godkjenne bilag",
          kind: "rettet",
          body: "Hvem som helst kunne endre hvordan bokførte bilag var fordelt på budsjettlinjer, på alle prosjekter. Nå kan bare prosjektleder, kunderådgiver og administrator fordele. Andre ser fordelingen som tekst.",
        },
      ],
    },
  ],
};
